import type React from 'react';
import { useParams } from 'react-router-dom';
import { AccountScene } from './AccountScene';
import { AppearanceScene } from './AppearanceScene';
import { ConnectorsScene } from './ConnectorsScene';
import { InstallAppScene } from './InstallAppScene';
import { LinkedAccountsScene } from './LinkedAccountsScene';
import { MemoryScene } from './MemoryScene';
import { NotificationsScene } from './NotificationsScene';
import { PermissionsScene } from './PermissionsScene';
import { PrivacyScene } from './PrivacyScene';
import { SettingsPlaceholderScene } from './SettingsPlaceholderScene';
import { SkillsScene } from './SkillsScene';
import { UsageScene } from './UsageScene';

const SCENES: Record<string, () => React.ReactElement> = {
  account: AccountScene,
  notifications: NotificationsScene,
  appearance: AppearanceScene,
  privacy: PrivacyScene,
  permissions: PermissionsScene,
  connectors: ConnectorsScene,
  skills: SkillsScene,
  usage: UsageScene,
  memory: MemoryScene,
  'linked-identities': LinkedAccountsScene,
  'linked-accounts': LinkedAccountsScene,
  install: InstallAppScene,
};

export function SettingsRoute() {
  const { slug } = useParams<{ slug: string }>();
  const Scene = slug ? SCENES[slug] : undefined;

  if (!Scene) {
    return <SettingsPlaceholderScene />;
  }

  return <Scene />;
}
